import {clientsClaim as workbox_core_clientsClaim} from '/var/www/talkvio-ui/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/var/www/talkvio-ui/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {registerRoute as workbox_routing_registerRoute} from '/var/www/talkvio-ui/node_modules/workbox-routing/registerRoute.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from '/var/www/talkvio-ui/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from '/var/www/talkvio-ui/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/index.html",
    "revision": "c9c11cdd0420fa30a3022c96f1035cdb"
  },
  {
    "url": "/static/css/419.9e62c0d6.chunk.css",
    "revision": null
  },
  {
    "url": "/static/css/653.ef2b9b0c.chunk.css",
    "revision": null
  },
  {
    "url": "/static/css/main.9bc3bb0d.css",
    "revision": null
  },
  {
    "url": "/static/js/287.031174db.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/378.b778dd3c.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/419.c8bbad20.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/624.251ff8b1.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/65.27727090.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/653.a153ce9a.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/787.614fb544.chunk.js",
    "revision": null
  },
  {
    "url": "/static/js/main.39f9fb38.js",
    "revision": null
  },
  {
    "url": "/static/js/main.39f9fb38.js.LICENSE.txt",
    "revision": "f5c6d0d716244629ac98e7b2cec20b82"
  },
  {
    "url": "/static/media/404_error_maskot.5101dd235cc82cd41783.png",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3-UBGEe.b104e2827cc0c0d480aa.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3CUBGEe.9b5735a40ff01027a224.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3GUBGEe.de0c6601fa3c21635548.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3KUBGEe.3aec290a3ccfd74dc75e.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3OUBGEe.8e8d3dc5c1755c044162.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3iUBGEe.98143bb168e1622fcf52.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMa3yUBA.d27b0fe5167938aa0821.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMawCUBGEe.641af3820cbbcb87a644.woff2",
    "revision": null
  },
  {
    "url": "/static/media/KFO7CnqEu92Fr1ME7kSn66aGLdTylUAMaxKUBGEe.c5cd32ef1611fd8054ae.woff2",
    "revision": null
  },
  {
    "url": "/static/media/apk-logo.f656ccc3416bf3ddf134.png",
    "revision": null
  },
  {
    "url": "/static/media/contest_1.ebcd17ddf9a849078209.png",
    "revision": null
  },
  {
    "url": "/static/media/contest_2.21d5a2b8e2a0b1849690.png",
    "revision": null
  },
  {
    "url": "/static/media/default-customback.77804d1b174143a06efc.avif",
    "revision": null
  },
  {
    "url": "/static/media/default-customback.7ef5ca143fc2d91d41d3.webp",
    "revision": null
  },
  {
    "url": "/static/media/google-play-logo.ca3b1e34d18fc3a2e68d.png",
    "revision": null
  },
  {
    "url": "/static/media/keybuttons.b7ae38dc43f775b3f38b.png",
    "revision": null
  },
  {
    "url": "/static/media/refcontest_1.965f38ecca794200fb88.png",
    "revision": null
  },
  {
    "url": "/static/media/refcontest_2.591c879d67843bf18797.png",
    "revision": null
  }
], {});

workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("/index.html"), {
  
  denylist: [/file\/.*/,/files\/.*/,/\.well-known\/assetlinks\.json$/],
}));






